var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideDashChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_2485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.875 0.875C1.35898 0.875 1.75 1.26602 1.75 1.75V10.9375C1.75 11.1781 1.94687 11.375 2.1875 11.375H13.125C13.609 11.375 14 11.766 14 12.25C14 12.734 13.609 13.125 13.125 13.125H2.1875C0.978906 13.125 0 12.1461 0 10.9375V1.75C0 1.26602 0.391016 0.875 0.875 0.875ZM4.375 6.125C4.85898 6.125 5.25 6.51602 5.25 7V8.75C5.25 9.23398 4.85898 9.625 4.375 9.625C3.89102 9.625 3.5 9.23398 3.5 8.75V7C3.5 6.51602 3.89102 6.125 4.375 6.125ZM7.875 4.375V8.75C7.875 9.23398 7.48398 9.625 7 9.625C6.51602 9.625 6.125 9.23398 6.125 8.75V4.375C6.125 3.89102 6.51602 3.5 7 3.5C7.48398 3.5 7.875 3.89102 7.875 4.375ZM9.625 5.25C10.109 5.25 10.5 5.64102 10.5 6.125V8.75C10.5 9.23398 10.109 9.625 9.625 9.625C9.14102 9.625 8.75 9.23398 8.75 8.75V6.125C8.75 5.64102 9.14102 5.25 9.625 5.25ZM13.125 2.625V8.75C13.125 9.23398 12.734 9.625 12.25 9.625C11.766 9.625 11.375 9.23398 11.375 8.75V2.625C11.375 2.14102 11.766 1.75 12.25 1.75C12.734 1.75 13.125 2.14102 13.125 2.625Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_2485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideDashChart);
export default __webpack_public_path__ + "static/media/sideDashChart.f6b72e3dc384eb712994592cbdec151e.svg";
export { ForwardRef as ReactComponent };